import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
// import MainButton from 'components/button/main/main_button'
import { Pair } from '../../components'

import styles from './ActivityPreview.scss'

import BackIcon from 'assets/images/icon_back.svg'

class ActivityPreview extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			pair_data: null,
		}
	}

	onSelectPairHandler = id => {
		const data = this.props.pairs.find(item => id === item.id)
		this.setState({
			pair_data: data,
		})
	}

	onBackSelected = () => {
		this.setState({
			pair_data: null,
		})
	}

	sharePair = () => {
		const sharingData = {
			type: this.state.pair_data ? 'matching_pairs_pair' : 'matching_pairs_grid',
			data: this.state.pair_data || this.props.pairs,
		}
		this.props.sharePair(sharingData)
	}

	render() {
		return (
			<div styleName="ActivityPreview">
				<div styleName='header'>
					<div styleName='header-back'>
						{this.state.pair_data && <button styleName='header-back-btn' onClick={this.onBackSelected}>
							<Isvg styleName='header-back-btn-icon' src={BackIcon} cacheGetRequests={true} />
							<span styleName='header-back-btn-label'>{localize('matching_pairs_preview_back')}</span>
						</button>}
					</div>
					<p styleName='header-title'>
						{localize('matching_pairs_preview_title')}
					</p>
					<div styleName='header-cta'>
						{/* TRA-KEY */}
						{/* Share button, to be included in a future version */}
						{/* <MainButton size='small' bgColor='blue' fontColor='white' onClick={this.sharePair}>Share</MainButton> */}
					</div>
				</div>
				{!this.state.pair_data && <div styleName={
					cn({
						grid: true,
					})
				}>
					{this.props.pairs.map(pair => (
						<div styleName={
							cn({
								'grid-pair': true,
							})}
						style={{width: this.props.pair_data.width + 'px', height: this.props.pair_data.height + 'px', display: 'inline-block'}}
						key={pair.id}
						>
							<Pair
								id={pair.id}
								card1={{type: pair.card1.type, value: pair.card1.value}}
								card2={{type: pair.card2.type, value: pair.card2.value}}
								selectPairHandler={this.onSelectPairHandler}
							/>
						</div>
					))}
				</div>}
				{this.state.pair_data &&
					<div styleName='single-pair'>
						<div styleName='single-pair-container'>
							<Pair
								card1={{type: this.state.pair_data.card1.type, value: this.state.pair_data.card1.value}}
								card2={{type: this.state.pair_data.card2.type, value: this.state.pair_data.card2.value}}
								noHover={true}
							/>
						</div>
					</div>
				}
			</div>
		)
	}
}

ActivityPreview.propTypes = {
	hideModal: PropTypes.func.isRequired,
	pairs: PropTypes.array,
}

ActivityPreview.defaultProps = {
	pairs: [],
}

export default CSSModules(ActivityPreview, styles, { allowMultiple: true })
